export type BillingsOrderCargoTaxiCreateRequestBillingNode = {
  id: string;
  nodeId: string;
  checkoutEventId?: string;
  lat: number;
  lon: number;
  description: string;
  editableCoordinates: boolean;
  checkoutDate?: Date;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
};

export enum BillingsOrderCargoTaxiCreateRequestContributionType {
  DISCOUNT_OPTIMIZATION = "DISCOUNT_OPTIMIZATION",
  DISCOUNT_BEING_LATE = "DISCOUNT_BEING_LATE",
  DISCOUNT_INCOMPATIBLE_CAR = "DISCOUNT_INCOMPATIBLE_CAR",
  DISCOUNT_OTHER = "DISCOUNT_OTHER",
  CONTRACT_CORRECTION_PERCENTAGE = "CONTRACT_CORRECTION_PERCENTAGE",
}

export type BillingsOrderCargoTaxiCreateRequestContributionContractCorrectionPercentage =
  {
    type: BillingsOrderCargoTaxiCreateRequestContributionType.CONTRACT_CORRECTION_PERCENTAGE;
    comment?: string;
    percentage: number;
    amount: number;
  };

export type BillingsOrderCargoTaxiCreateRequestContributionDiscountOptimization =
  {
    type: BillingsOrderCargoTaxiCreateRequestContributionType.DISCOUNT_OPTIMIZATION;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiCreateRequestContributionDiscountBeingLate = {
  type: BillingsOrderCargoTaxiCreateRequestContributionType.DISCOUNT_BEING_LATE;
  comment?: string;
  amount: number;
};

export type BillingsOrderCargoTaxiCreateRequestContributionDiscountIncompatibleCar =
  {
    type: BillingsOrderCargoTaxiCreateRequestContributionType.DISCOUNT_INCOMPATIBLE_CAR;
    comment?: string;
    amount: number;
  };

export type BillingsOrderCargoTaxiCreateRequestContributionDiscountOther = {
  type: BillingsOrderCargoTaxiCreateRequestContributionType.DISCOUNT_OTHER;
  comment?: string;
  amount: number;
};

export type BillingsOrderCargoTaxiCreateRequestContribution =
  | BillingsOrderCargoTaxiCreateRequestContributionContractCorrectionPercentage
  | BillingsOrderCargoTaxiCreateRequestContributionDiscountOptimization
  | BillingsOrderCargoTaxiCreateRequestContributionDiscountBeingLate
  | BillingsOrderCargoTaxiCreateRequestContributionDiscountIncompatibleCar
  | BillingsOrderCargoTaxiCreateRequestContributionDiscountOther;

export type BillingsOrderCargoTaxiCreateRequestBody = {
  billingNodes: BillingsOrderCargoTaxiCreateRequestBillingNode[];
  billingContributions: BillingsOrderCargoTaxiCreateRequestContribution[];
};

type BillingsOrderCargoTaxiCreateRequest = {
  orderUuid: string;
  billingNodes: BillingsOrderCargoTaxiCreateRequestBillingNode[];
  billingContributions: BillingsOrderCargoTaxiCreateRequestContribution[];
};

export default BillingsOrderCargoTaxiCreateRequest;
